const lists = {
    "languages_list":{
        "ro":"Румынский",
        "ru":"Русский",
        "en":"Английский",
    },
    "genders_list":{
        "":"Не указано",
        "male":"Мужчина",
        "female":"Женщина",
    }
};
export default lists